import type { SupportedLocale } from '../i18n/locales'

/**
 * Open Graph `og:locale` expects `xx_YY` (POSIX style). Our `SUPPORTED_LOCALES`
 * use BCP 47 with `xx-YY` / `xx-Hans`. Region-only swap suffices for most:
 * write-system tags (`zh-Hans`, `zh-Hant`) collapse to `zh_CN` / `zh_TW`
 * per Facebook's locale table.
 */
export function localeToOgTag(locale: SupportedLocale): string {
  switch (locale) {
    case 'zh-Hans':
      return 'zh_CN'
    case 'zh-Hant':
      return 'zh_TW'
    case 'pt-BR':
      return 'pt_BR'
    case 'pt':
      return 'pt_PT'
    case 'en':
      return 'en_GB'
    default:
      return locale.replace('-', '_')
  }
}
